
import { createFormHook, createFormHookContexts } from "@tanstack/react-form";
import Field from "./ui/Field";


export const { fieldContext, formContext, useFieldContext, useFormContext } = createFormHookContexts();

const { useAppForm } = createFormHook({
	fieldContext,
	formContext,
	fieldComponents: {
		Date: Field.Date,
		Enum: Field.Enum,
		Image: Field.Image,
		Input: Field,
		Phone: Field.Phone,
		Select: Field.Select
	},
	formComponents: {}
});

export const useForm = useAppForm;